import { apiService } from '../api';
import { SectionInstance } from '../../types/sessions';

export interface CreateSectionInstanceInput {
  sessionId: string;
  classId: string;
  name: string;
  classTeacherId?: string | null;
  room?: string;
  capacity?: number;
}

export interface UpdateSectionInstanceInput {
  name?: string;
  classTeacherId?: string | null;
  room?: string | null;
  capacity?: number | null;
  isActive?: boolean;
}

export const sectionInstancesApi = {
  // `relationship` only affects Teacher-role callers (BE ignores it for
  // everyone else). Pass 'class-teacher' on attendance surfaces where the
  // homeroom owns the action, 'subject-teacher' on marks surfaces, or
  // omit on generic dropdowns.
  list: async (filter: {
    sessionId?: string;
    classId?: string;
    relationship?: 'class-teacher' | 'subject-teacher';
  }) => {
    const response = await apiService.get<SectionInstance[]>('/section-instances', filter);
    return response.data ?? [];
  },

  get: async (id: string) => {
    const response = await apiService.get<SectionInstance>(`/section-instances/${id}`);
    return response.data!;
  },

  create: async (input: CreateSectionInstanceInput) => {
    const response = await apiService.post<SectionInstance>('/section-instances', input);
    return response.data!;
  },

  update: async (id: string, input: UpdateSectionInstanceInput) => {
    const response = await apiService.put<SectionInstance>(`/section-instances/${id}`, input);
    return response.data!;
  },

  remove: async (id: string) => {
    await apiService.delete(`/section-instances/${id}`);
  },

  bulkCopyFromSession: async (input: {
    sourceSessionId: string;
    targetSessionId: string;
    classIds?: string[];
  }) => {
    const response = await apiService.post<{ created: number; skipped: number }>(
      '/section-instances/bulk-copy',
      input
    );
    return response.data!;
  }
};
